export const PATHS = {
  FLEET: `fleet`,
  REBATES: `rebates`,
  INSIGHTS: {
    BASE: `insights`,
    SPEEDING: `speeding`,
    VEHICLES: `vehicles`,
    TRIPS: `trips`,
  },
  CLAIMS: `claims`,
  CLAIM_SUBMISSIONS: {
    BASE: `claim-submissions`,
    REVIEW: `review`,
  },
  CREATE_CLAIM_SUBMISSION: `create-claim-submission`,
  MILEAGE: `mileage`,
  BILLING: `billing`,
}
